import { useState } from 'react'
import { useUnit } from 'effector-react'
import { capitalize } from 'lodash'
import { Button, Divider, Flex, Form, Modal, Select, Typography } from 'antd'
import { createPeriodFx } from 'src/pages/budget/budgetRequests/model'
import { REQUIRED_FIELD } from 'src/pages/budget/const'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'

dayjs.locale('ru')

type FormValue = {
  period: string
}

export const ButtonCreateBudget = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { Text } = Typography
  const { Item } = Form
  const [form] = Form.useForm()

  const loading = useUnit(createPeriodFx.pending)

  const options = [
    {
      label: capitalize(dayjs().format('MMMM YYYY')),
      value: dayjs().format('YYYY-MM'),
    },
    {
      label: capitalize(dayjs().add(1, 'month').format('MMMM YYYY')),
      value: dayjs().add(1, 'month').format('YYYY-MM'),
    },
  ]

  const handleSubmit = async ({ period }: FormValue) => {
    try {
      await createPeriodFx({
        body: { period },
      })
      handleCancel()
    } catch (error) {
      console.error(error)
    }
  }

  const handleCancel = () => {
    form.resetFields()
    setIsModalOpen(false)
  }

  return (
    <>
      <Button
        size="large"
        color="green"
        variant="outlined"
        onClick={() => setIsModalOpen(true)}
      >
        Создать первый период
      </Button>
      <Modal
        title={<div style={{ fontSize: 20 }}>Создание бюджетного периода</div>}
        open={isModalOpen}
        centered
        closable={!loading}
        maskClosable={!loading}
        onCancel={handleCancel}
        footer={null}
      >
        <Divider />
        <Form<FormValue> layout="inline" onFinish={handleSubmit} form={form}>
          <Item
            style={{ minHeight: 55 }}
            label={
              <Text style={{ fontSize: 18 }} type="secondary">
                Период *
              </Text>
            }
            name="period"
            required={false}
            rules={[{ required: true, message: REQUIRED_FIELD }]}
          >
            <Select
              style={{ width: 230 }}
              placeholder="Выберите первый период"
              showSearch
              allowClear
              options={options}
            />
          </Item>
          <Divider style={{ marginTop: 6 }} />
          <Flex gap={8} style={{ width: '100%' }}>
            <Button size="large" style={{ flex: 1 }} onClick={handleCancel}>
              Отменить
            </Button>
            <Button
              size="large"
              style={{ flex: 1 }}
              type="primary"
              htmlType="submit"
              loading={loading}
            >
              Создать
            </Button>
          </Flex>
        </Form>
      </Modal>
    </>
  )
}
